import React from 'react'

function MyButton({link}) {

    return (
        <a href={link} target = "_blank" rel="noopener noreferrer"> {/*"remove targe and rel to keep it in the same page"*/}
            <button className="border-4 border-gray-300 text-gray-100 [background-color:#010101] hover:bg-gray-600 px-4 py-3 rounded-full justify-center font-bold">
                Launch Github Repo
            </button>
        </a>
    );
}
function StremButton({link}) {

    return (
        <a href={link} target = "_blank" rel="noopener noreferrer"> {/*"remove targe and rel to keep it in the same page"*/}
            <button className="border-4 border-gray-300 text-gray-100 [background-color:#010101] hover:bg-gray-600 px-4 py-3 rounded-full justify-center font-bold">
                Open Video On StreamWest
            </button>
        </a>
    );
}



const StreamWestVideoPlayer = () => {
  return (

    <div className='flex flex-col items-center justify-center py-10'>
        <div className='mb-4'>
            <p className='flex flex-items justify-center mb-3 text-xl'>Solitaire Gameplay Example:</p>
            <p className='flex flex-items justify-center'>Solitaire example game running in cpp using raylib, streamed </p>
            <p className='flex flex-items justify-center mb-3'>and uploaded through my streaming service StreamWest</p>
            <video width="800" height="450" className='mb-3' controls rounded>
                <source src="https://res.cloudinary.com/diyi9oqge/video/upload/v1757457981/my_videos/we4arcwgauk2xe97f5pm.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
            </video>
            <div className='flex flex-items justify-center'>
                <MyButton  link = {"https://github.com/walkmoody/Solitaire"}/>
                <StremButton  link = {"https://streamwest.wamoody.com/video/68c0ae40cd2d0b747560a9e3"}/>
            </div>
        </div>
        <div className='mb-4'>
            <p className='flex flex-items justify-center mb-3 text-xl'>Mario Python Gameplay Example:</p>
            <p className='flex flex-items justify-center'>Mario example game running in python using pygames, streamed </p>
            <p className='flex flex-items justify-center mb-3'>and uploaded through my streaming service StreamWest</p>
            <video width="800" height="450" className='mb-3' controls rounded>
                <source src="https://res.cloudinary.com/diyi9oqge/video/upload/v1757467629/my_videos/ktljwrp0gkjlaq2dt7ei.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
            </video>
            <div className='flex flex-items justify-center'>
                <MyButton  link = {"https://github.com/walkmoody/MarioPython"}/>
                <StremButton  link = {"https://streamwest.wamoody.com/video/68c0d3efcd2d0b747560a9e8"}/>
            </div>
        </div>
    </div>
  )
}

export default StreamWestVideoPlayer
